import React from 'react'
import { useTranslation } from 'react-i18next'

import BackgroundServices from 'src/assets/image/bg-services.png'
import ImageBenefit1 from 'src/assets/image/img-benefit-1.jpg'
import ImageBenefit2 from 'src/assets/image/img-benefit-2.jpg'
import ImageBenefit3 from 'src/assets/image/img-benefit-3.jpg'
import ImageBenefit4 from 'src/assets/image/img-benefit-4.jpg'
import ImageBenefit5 from 'src/assets/image/img-benefit-5.jpg'
import ImageBenefit6 from 'src/assets/image/img-benefit-6.jpg'
import ImageBenefit7 from 'src/assets/image/img-benefit-7.jpg'
import ImageBenefit8 from 'src/assets/image/img-benefit-8.jpg'
import ImageProcess from 'src/assets/image/img-process.png'

import ImageComponent from 'src/component/core/image'

export default function Content() {
    const { t } = useTranslation()

    const listOfBenefits = [
        {
            id: 0,
            description:
                'Third-party verification gives your greenhouse gas (GHG) reporting the seal of authenticity \nIt ensures that your emissions data is accurate and reliable reinforcing trust with regulators, investors, and the public \n In a world increasingly focused on environmental accountability, transparency matters more than ever',
            image: ImageBenefit1,
            title: 'Builds Trust and Credibility',
        },
        {
            id: 1,
            description: `Stay ahead of evolving climate regulations with verified GHG data\n Whether you're part of a mandatory emissions trading system or preparing sustainability disclosures, verification ensures your reporting aligns with national and international standards avoiding penalties and enhancing readiness for audits`,
            image: ImageBenefit2,
            title: 'Ensures Regulatory Compliance',
        },
        {
            id: 2,
            description:
                'Verification helps you catch errors, inconsistencies, or gaps in emissions reporting before they become costly liabilities \n By identifying risks early, you can take corrective action, strengthen internal controls, and protect your organization from reputational or legal fallout',
            image: ImageBenefit3,
            title: 'Reduces Risk and Exposure',
        },
        {
            id: 3,
            description: `Knowing where you stand is essential to knowing where you're headed \nVerified GHG data provides a solid foundation for tracking your emissions over time, setting reduction targets, and measuring progressIt's the key to moving from climate intentions to climate action`,
            image: ImageBenefit4,
            title: 'Enables Accurate Performance Tracking',
        },
        {
            id: 4,
            description: `In a competitive market, verified environmental claims can set your business apart \nGHG verification shows you're serious about sustainability—helping you win customer loyalty, stand out in procurement processes, and build a brand that reflects your values`,
            image: ImageBenefit5,
            title: 'Strengthens Your Brand',
        },
        {
            id: 5,
            description: `Environmental, Social, and Governance (ESG) factors are now central to many investors' decisions\nVerified GHG disclosures give investors confidence that your data is accurate, your goals are measurable, and your commitment to climate action is real`,
            image: ImageBenefit6,
            title: 'Attracts Investor Confidence',
        },
        {
            id: 6,
            description:
                'Verified emissions data is often a prerequisite for green bonds, climate funds, and sustainability- linked loans\nIt signals to financiers that your organization is managing carbon risk responsibly— and that your projects are eligible for climate- aligned capital',
            image: ImageBenefit7,
            title: 'Unlocks Access to Green Finance',
        },
        {
            id: 7,
            description:
                'GHG verification creates a culture of precision and responsibility\nIt pushes teams to collaborate more effectively, document processes thoroughly, and take ownership of emissions performance—leading to stronger climate governance across your organization',
            image: ImageBenefit8,
            title: 'Encourages Internal Accountability',
        },
    ]

    return (
        <div className="relative w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24">
            <div className="flex flex-col gap-12 sm:gap-16">
                {/* Our Services */}
                <div className="flex flex-col gap-6">
                    <h2 className="font-bold text-2xl sm:text-3xl">Our Services</h2>

                    <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start md:items-center">
                        <div className="w-full md:w-[400px] shrink-0">
                            <ImageComponent
                                src={BackgroundServices}
                                alt="Services"
                                className="w-full h-auto rounded-2xl object-cover"
                            />
                        </div>

                        <div className="flex flex-col gap-2">
                            <h6 className="font-bold text-lg sm:text-xl">
                                GHG Verification for Organizational Level
                            </h6>
                            <p className="text-sm sm:text-base leading-relaxed">
                                Voluntary Scheme for Implementation of Verification at organization level
                            </p>
                            <p className="text-sm sm:text-base leading-relaxed">
                                Refering to SNI ISO 14064- 1:2018
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col gap-4">
                        <h5 className="font-bold text-lg sm:text-xl">Scope of Work</h5>
                        <ul className="list-disc pl-5 space-y-1 text-sm sm:text-base">
                            <li>Power Generation & Electric Power Transaction</li>
                            <li>General Manufacturing [Physical/Chemical Transformation of Materials]</li>
                            <li>Metals Production</li>
                            <li>Mining</li>
                        </ul>
                    </div>
                </div>

                {/* Process */}
                <div className="flex flex-col gap-6">
                    <h2 className="font-bold text-2xl sm:text-3xl">Validation/Verification Process</h2>

                    <div className="w-full overflow-hidden rounded-2xl">
                        <ImageComponent src={ImageProcess} alt="Process" className="w-full h-auto object-contain" />
                    </div>
                </div>

                {/* Benefits */}
                <div className="flex flex-col gap-8 sm:gap-10">
                    <h2 className="font-bold text-2xl sm:text-3xl">Benefits of GHG Verification/Validation</h2>

                    {listOfBenefits.map((item) => {
                        const isOdd = item.id % 2 !== 0

                        return (
                            <div
                                key={item.id}
                                className={[
                                    'flex flex-col md:flex-row gap-6 md:gap-10',
                                    'items-start md:items-center',
                                    isOdd ? 'md:flex-row-reverse' : '',
                                ].join(' ')}
                            >
                                <div className="w-full md:w-1/2">
                                    <ImageComponent
                                        src={item.image}
                                        alt={`Benefit ${item.id}`}
                                        className="w-full h-auto rounded-3xl object-cover aspect-[4/3]"
                                    />
                                </div>

                                <div className="w-full md:w-1/2 flex flex-col gap-2">
                                    <h6 className="font-bold text-lg sm:text-xl">{item.title}</h6>
                                    <p className="text-sm sm:text-base leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
